/**
 * Converts a "YYYY-MM-DD HH:mm:ss" string (no timezone) to a UTC Date object.
 * Example input: "2025-10-06 03:59:59"
*/

export function parseApiDateToUtc(dateStr: string): Date {
   const [datePart, timePart] = dateStr.split(' ');
   const [year, month, day] = datePart.split('-').map(Number);
   const [hour, minute, second] = timePart.split(':').map(Number);
 
   // Create as UTC — note: months are 0-based
   return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
}


export function getQuarterText(reportTypeSection: string, reportTypeYear: number | string): string {
   const normalized = reportTypeSection?.toUpperCase();

   if (normalized === 'ANNUAL') {
      return `${reportTypeYear} Annual Report`;
   }

   const quarterMap: Record<string, string> = {
      'FIRST_QUARTER': '1st',
      'SECOND_QUARTER': '2nd',
      'THIRD_QUARTER': '3rd',
      'FOURTH_QUARTER': '4th'
   };

   const quarter = quarterMap[normalized] || '';
   return `${reportTypeYear} ${quarter} Quarter Report`;
}

export function formatUtcDateToETDisplay(date: Date): string {
   const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
   }).formatToParts(date);

   const get = (type: string) => parts.find(p => p.type === type)?.value;

   return `${get('month')} ${get('day')} @${get('hour')}:${get('minute')} ${get('dayPeriod')} ET`;
}